module.exports = __webpack_public_path__ + "media/images/app/thank-you-page/thankyou-hero-mobile-42b127e63b870b58c6b664dac5d4c1b2.webp";